<div>
  <mat-toolbar>
    <span>{{ tableField?.name }}</span>
    <span class="spacer"></span>
    @if (!isGuest) {
      <button
        mat-icon-button
        [disabled]="disableEdit"
        [matTooltip]="'ADD_ROW' | transloco"
        (click)="onClickAddRow()"
      >
        <mat-icon>add</mat-icon>
      </button>
      <button
        mat-icon-button
        [disabled]="disableEdit"
        [matTooltip]="'DELETE_ROW' | transloco"
        (click)="onClickDelete()"
      >
        <mat-icon>delete</mat-icon>
      </button>
      @if (showSave) {
        <button
          mat-icon-button
          [matTooltip]="'SAVE' | transloco"
          [disabled]="disableEdit || !isDirty"
          (click)="onClickSave()"
        >
          <mat-icon>save</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        [matMenuTriggerFor]="moreMenu"
        aria-label="More Table Field Actions Menu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #moreMenu="matMenu">
        <button
          mat-menu-item
          [disabled]="disableEdit"
          [class.disabled]="disableEdit"
          (click)="onClickImportCSV()"
        >
          <span transloco="IMPORT_CSV"></span>
        </button>
        <button mat-menu-item [disabled]="disableEdit" (click)="onClickPaste()">
          <span transloco="PASTE"></span>
        </button>
        <mat-divider></mat-divider>
        <button
          mat-menu-item
          [disabled]="disableDownloadAsCSV"
          [matMenuTriggerFor]="downloadCsvMenu"
        >
          <span transloco="DOWNLOAD_AS_CSV"></span>
        </button>
      </mat-menu>
      <mat-menu #downloadCsvMenu="matMenu">
        <button mat-menu-item (click)="onClickDownloadAsCsv(false)">
          <span transloco="DEFAULT_CONFIGURATION"></span>
        </button>
        <button mat-menu-item (click)="onClickDownloadAsCsv(true)">
          <span transloco="ADVANCED_CONFIGURATION"></span>
        </button>
      </mat-menu>
      <!-- Below is the input used for programmatic reading of csv files from the clipboard. -->
      <input
        type="file"
        #csvInput
        style="display: none"
        (change)="onFileSelected($event)"
        accept=".csv"
      />
    }
    @if (!overrideHeight()) {
      <button
        mat-icon-button
        [matTooltip]="'Toggle compact mode' | transloco"
        (click)="onClickToggleCompactMode()"
      >
        @if (useCompactMode()) {
          <mat-icon>expand_more</mat-icon>
        } @else {
          <mat-icon>expand_less</mat-icon>
        }
      </button>
    }
    <button
      mat-icon-button
      [matTooltip]="'CLOSE' | transloco"
      (click)="onClickClose()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <ag-grid-angular
    #tableFieldGrid
    class="ag-theme-material"
    [gridOptions]="gridOptions"
    [ngStyle]="gridStyle()"
  >
  </ag-grid-angular>
</div>
